<template>
  <div class="text-left">
    <p class="text-sm text-grey-3 text-opacity-60 mb-4">
      {{ $t('auto_investment.setup.first_step.popup.text_1') }}
    </p>
    <p class="font-bold text-sm text-grey-3 mb-4">
      {{ $t('auto_investment.setup.first_step.popup.how_it_works') }}
    </p>
    <p class="text-sm text-grey-3 text-opacity-60 mb-4">
      {{ $t('auto_investment.setup.first_step.popup.text_2') }}
    </p>

    <div class="indented-custom-bullet">
      <ul>
        <li
          v-for="item in $tm('auto_investment.setup.first_step.popup.list').map((text, idx) => {
            return idx === 1
              ? text.replace('{amount}', dollarFormatting(minInvestment))
              : text;
          })"
          v-bind:key="item"
          class="mb-3 pl-4 text-sm text-grey-3"
        >
          {{ item }}
        </li>
      </ul>
    </div>

    <div class="text-sm text-grey-3 text-opacity-60">
      <p>{{ $t('auto_investment.setup.first_step.popup.text_3') }}</p>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import useGlobalHelpers from '@/mixins/useGlobalHelpers'

export default {
  setup() {
    const { tm } = useI18n()
    const { dollarFormatting } = useGlobalHelpers()
    const store = useStore()
    const minInvestment = computed(() => {
        return store.state.general?.settings?.min_investment ?? 1000
    })

    return {
      tm,
      dollarFormatting,
      minInvestment
    }
  }
} 

</script>
